<template>
    <div v-if="visible">
        <el-dialog title="设置关联学校" :close-on-click-modal="false" :visible.sync="visible" :before-close="dialogClose" width="380px">    
             <el-form ref="form" :model="form" :rules="rules" label-width="110px">
                <el-form-item label="当前学校名称：">
                    {{form.schoolName}}
                </el-form-item>
                <el-form-item   prop="targetDeptId" label="关联学校：">
                    <el-select v-model="form.targetDeptId" multiple collapse-tags  clearable placeholder="请选择">
                        <el-option
                            v-for="item in depts"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="visible=false">取消</el-button>
                <el-button type="primary" @click="save()">确定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
       
<script>
    import http from '../../../../common/http'; 

    export default {
        components:{},
        data(){
            return{
                loading:false,
                visible: false,
                form: {
                    schoolId: "", // 学校ID
                    schoolName: "", // 学校名称
                    targetDeptId: undefined
                },
                depts:[],
                rules: {
                    targetDeptId: [
                        { required: true, message: '请选择关联学校', trigger: 'blur' }
                    ]
                }
            }
        },
        methods:{
            init(data){
                // 初始数据
                this.visible = true
                this.form.schoolId = data.id
                this.form.schoolName = data.name
                if(!this.$util.isEmpty(data.bindDeptIds)){
                    this.form.targetDeptId = data.bindDeptIds.split(',')
                }
                // 查询数据
                this.getData()
            },
            getData(){
                this.loading=true
                let url  = this.getDeptAllSchoolUrl
                let data = {
                    currDeptId: this.form.schoolId
                }
                this.apiPost(url,data).then((res) => {
                    // console.log(JSON.stringify(res.data));
                    if(res.status == 200){
                       this.depts = res.data
                    }else{
                        this.$commonFn.showTip(res.message,3)
                    }
                    this.loading=false
                },(err)=>{
                    console.log(err)
                    this.loading=false
                });
            },
            save(){
                this.$refs['form'].validate((valid) => {
                    if(valid){
                        let url= this.deptSetAssociationDeptUrl
                        let data = {
                            currentDeptId: this.form.schoolId,
                            associationDeptId: this.form.targetDeptId.join(',')
                        };
                        // console.log(JSON.stringify(data))
                        // return
                        this.apiPost(url, data).then((res) => {
                            if(res.status == 200){
                                this.$commonFn.showTip(res.message,1)
                                this.visible=false
                                this.$parent.getData()
                            }else{
                                this.$commonFn.showTip(res.message,3)
                            }
                        }, (err) => {
                            console.log(err)
                        });
                    }
                });
            },
            dialogClose(done){
                done()
                this.$parent.getData()
            },
            load(tree, treeNode, resolve) {
                console.log('加载数据...')
            }
        },
        mixins: [http]
    }

</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/page/sys/dept/SetBindSchool.vue